import { topicList } from '@/mocks/homeMock';

export default function Topics() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-600">
              <i className="ri-folder-open-line" />
              TOPICS
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">热门主题盘点</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">按主题持续追踪全网热点，直达你最关心的那个瓜。</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topicList.map((t) => (
            <a
              key={t.name}
              href="#breaking"
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:border-accent-300 hover:shadow-[0_16px_40px_-24px_rgba(0,0,0,0.25)]"
            >
              <div className="relative h-40 overflow-hidden">
                <img src={t.img} alt={t.name} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent" />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-600">
                  {t.count} 条追踪
                </span>
                <span className="absolute bottom-3 left-3 font-heading text-xl font-black text-background-50">{t.name}</span>
              </div>
              <div className="flex items-center justify-between p-4">
                <p className="text-sm text-foreground-600">{t.desc}</p>
                <span className="ml-2 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}